import { useNavigate } from "react-router-dom";
import { ChevronDown, ChevronUp, Pencil } from "lucide-react";
import { ListingLinkButton, ScoreBadge } from "@/components/common/Primitives";
import { bpmMobileText, isManualBpm } from "@/components/opportunities/tableCells";
import { eur, eurSigned, pct, vehicleSpecShort, vehicleTitle } from "@/lib/format";

export const OpportunityMobileCard = ({ row, open, onToggle, onOverride }) => {
  const navigate = useNavigate();
  const v = row.vehicle_snapshot || {};
  const h = row.headline || {};
  const metrics = [
    ["Inkoop", eur(v.price)],
    [isManualBpm(row) ? "BPM (handmatig)" : "BPM", bpmMobileText(row)],
    ["Landed cost", eur(h.landed_cost)],
    ["NL waarde", eur(h.expected_market_value)],
    ["Bijdrage", eurSigned(h.contribution, { fallback: "—" })],
    ["ROI", pct(h.roi_pct, { fallback: "—" })],
  ];

  return (
    <div className="panel p-2.5" data-testid={`m-row-${row.listing_id}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="truncate text-[13px] font-semibold text-slate-900">
            {vehicleTitle(v)}
          </div>
          <div className="text-[11px] text-slate-500">{vehicleSpecShort(v)}</div>
        </div>
        <ScoreBadge score={h.deal_score} advice={h.advice} />
      </div>
      <div className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1 border-t border-slate-100 pt-2">
        {metrics.map(([label, value]) => (
          <div key={label} className="flex items-center justify-between">
            <span className="label-xs">{label}</span>
            <span className="mono text-[12px] font-semibold text-slate-800">{value}</span>
          </div>
        ))}
      </div>
      {open && (
        <div className="mt-2 space-y-1 border-t border-slate-100 pt-2 text-[11px] text-slate-600">
          <div>Betrouwbaarheid: {h.confidence_pct ?? "—"}%</div>
          <div>Liquiditeit: {row.liquidity?.label || "—"}</div>
          <div>NL vergelijkingsauto's: {row.valuation?.n_used ?? 0}</div>
        </div>
      )}
      <div className="mt-2 flex items-center gap-2">
        <button
          type="button"
          onClick={onToggle}
          data-testid={`m-expand-${row.listing_id}`}
          className="flex items-center gap-1 rounded-sm border border-slate-300 px-2 py-1 text-[11px] font-semibold text-slate-700"
        >
          {open ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}
          {open ? "Minder" : "Meer"}
        </button>
        <button
          type="button"
          onClick={() => navigate(`/auto/${row.listing_id}`)}
          data-testid={`m-details-${row.listing_id}`}
          className="rounded-sm border border-slate-300 px-2 py-1 text-[11px] font-semibold text-slate-700"
        >
          Details
        </button>
        <button
          type="button"
          onClick={() => onOverride(row)}
          data-testid={`m-bpm-edit-${row.listing_id}`}
          className="flex items-center gap-1 rounded-sm border border-slate-300 px-2 py-1 text-[11px] font-semibold text-slate-700"
        >
          <Pencil className="h-3 w-3" /> BPM
        </button>
        <ListingLinkButton url={v.url} testid={`m-listing-url-${row.listing_id}`} />
      </div>
    </div>
  );
};
